module.exports = __webpack_public_path__ + "img/allocated.3fbf2bf2.svg";